import React from "react";
import Icon from "@mdi/react";
import {
  mdiHomeOutline,
  mdiServerNetwork,
  mdiAccountGroupOutline,
  mdiAccountMultipleOutline,
  mdiMenu,
  mdiLogout,
  mdiPlus,
  mdiPencilOutline,
  mdiTrashCanOutline,
  mdiMagnify,
  mdiChevronDown,
  mdiClose,
  mdiChevronRight,
  mdiDotsVertical,
  mdiShape,
  mdiClockOutline,
  mdiBorderOutside,
  mdiBilliardsRack,
} from "@mdi/js";
import { THEME, BRAND_PRIMARY } from "./Styles";

export const ICONS = {
  HomeMdn: <Icon path={mdiHomeOutline} size={"16px"} color={THEME.palette.themePrimary} />,
  ServerEnviromentMdn: <Icon path={mdiServerNetwork} size={"16px"} color={THEME.palette.themePrimary} />,
  GroupMdn: <Icon path={mdiAccountGroupOutline} size={"16px"} color={THEME.palette.themePrimary} />,
  PeopleMdn: <Icon path={mdiAccountMultipleOutline} size={"16px"} color={THEME.palette.themePrimary} />,
  GlobalNavButtonMdn: <Icon path={mdiMenu} size={"16px"} color={THEME.palette.neutralPrimary} />,
  SignOutMdn: <Icon path={mdiLogout} size={"16px"} color={THEME.palette.white} />,
  AddMdn: <Icon path={mdiPlus} size={"16px"} color={THEME.palette.themePrimary} />,
  EditMdn: <Icon path={mdiPencilOutline} size={"16px"} color={THEME.palette.themePrimary} />,
  DeleteMdn: <Icon path={mdiTrashCanOutline} size={"16px"} color={THEME.palette.themePrimary} />,
  SearchMdn: <Icon path={mdiMagnify} size="16px" />,
  ChevronDownMdn: <Icon path={mdiChevronDown} size="16px" color="#323130" />,
  ChromeCloseMdn: <Icon path={mdiClose} size="16px" color="#323130" />,
  ChevronRightMedMdn: <Icon path={mdiChevronRight} size="16px" color="#323130" />,
  MoreMdn: <Icon path={mdiDotsVertical} size="25px" color="#ffff" />,
  Shape: <Icon path={mdiShape} size="16px" color={BRAND_PRIMARY} />,
  BorderOutside: <Icon path={mdiBorderOutside} size="16px" color={BRAND_PRIMARY} />,
  ClockOutLine: <Icon path={mdiClockOutline} size="16px" color={BRAND_PRIMARY} />,
  BilliardsRack: <Icon path={mdiBilliardsRack} size="16px" color={BRAND_PRIMARY} />,
};
